import { FC, useEffect, useRef } from 'react';
import { Typography } from 'shared/ui/typography';
import { MarginBottom, CardContent, HiddenContainer, Wrapper } from './styles';

export const OrderDateHeader: FC<{ date: string; withShadow?: boolean }> = ({
	date,
	withShadow,
}) => {
	const ref = useRef();

	const observer = new IntersectionObserver(
		([e]) =>
			e.target.classList.toggle('is-pinned', e.intersectionRatio < 1),
		{ threshold: [1] },
	);

	useEffect(() => {
		if (ref.current && withShadow) {
			observer.observe(ref.current);
		}
		//eslint-disable-next-line
	}, [ref.current]);

	useEffect(() => {
		return () => observer.disconnect();
		//eslint-disable-next-line
	}, []);

	return (
		<Wrapper ref={ref as any}>
			{withShadow && <HiddenContainer />}
			<MarginBottom>
				<CardContent>
					<Typography
						colorVariant="main"
						isBold={true}
						id={`date-header-${date}`}
						mode="large"
					>
						{date}
					</Typography>
				</CardContent>
			</MarginBottom>
		</Wrapper>
	);
};
